var Queue = class TinyQueue {
  constructor(data = [], compare = defaultCompare) {
    this.data = data;
    this.length = this.data.length;
    this.compare = compare;

    if (this.length > 0) {
      for (let i = (this.length >> 1) - 1; i >= 0; i--) this._down(i);
    }
  }

  push(item) {
    this.data.push(item);
    this.length++;
    this._up(this.length - 1);
  }

  pop() {
    if (this.length === 0) return undefined;

    const top = this.data[0];
    const bottom = this.data.pop();
    this.length--;

    if (this.length > 0) {
      this.data[0] = bottom;
      this._down(0);
    }

    return top;
  }

  peek() {
    return this.data[0];
  }

  _up(pos) {
    const { data, compare } = this;
    const item = data[pos];

    while (pos > 0) {
      const parent = (pos - 1) >> 1;
      const current = data[parent];
      if (compare(item, current) >= 0) break;
      data[pos] = current;
      pos = parent;
    }

    data[pos] = item;
  }

  _down(pos) {
    const { data, compare } = this;
    const halfLength = this.length >> 1;
    const item = data[pos];

    while (pos < halfLength) {
      let left = (pos << 1) + 1;
      let best = data[left];
      const right = left + 1;

      if (right < this.length && compare(data[right], best) < 0) {
        left = right;
        best = data[right];
      }
      if (compare(best, item) >= 0) break;

      data[pos] = best;
      pos = left;
    }

    data[pos] = item;
  }
};

function defaultCompare(a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
}

if (
  typeof Queue !== "function" &&
  Queue.default &&
  typeof Queue.default === "function"
) {
  Queue = Queue.default;
}

module.exports = function (graph, start, end) {
  var costs = {};
  costs[start] = 0;
  var initialState = [0, [start], start];
  var queue = new Queue([initialState], function (a, b) {
    return a[0] - b[0];
  });
  //var explored = {};

  while (queue.length) {
    var state = queue.pop();
    var cost = state[0];
    var node = state[2];
    if (node === end) {
      return state.slice(0, 2);
    }

    var neighbours = graph[node];
    Object.keys(neighbours).forEach(function (n) {
      var newCost = cost + neighbours[n];
      if (!(n in costs) || newCost < costs[n]) {
        costs[n] = newCost;
        var newState = [newCost, state[1].concat([n]), n];
        queue.push(newState);
      }
    });
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/geojson-path-finder/dijkstra.js